export default {"src":"/_next/static/media/DBF.f0a4ec09.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};